// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"16ca4e8e","142":"73d5b4c2","447":"feae8343","451":"5bbb3e3d","580":"e4b6b43c","675":"bf801c74","686":"5ef39532","735":"b882ca13","845":"f857bf70","869":"b4f3222d","884":"972840b9","992":"031d84f7"}[chunkId] + ".chunk.js";
};